import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from 'ramda';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { selectSalesQuotesCreatedItem, selectSalesQuotesQueryItems } from '../../../../../../redux/sales-quotes/selector';
import SalesQuoteComponent from '../components/sales-quote.component';
import { salesQuotes } from '../../../../../../redux/sales-quotes/action';
import PageLoader from '../../../../../../components/PageLoader';
import storePersist from '../../../../../../redux/storePersist';
import { deepCopy } from '../../../../../../common/services/common.service';
import { contacts } from '../../../../../../redux/contacts/action';
import { selectContactsListItems } from '../../../../../../redux/contacts/selector';
import { customers } from '../../../../../../redux/customers/action';
import { selectCustomersListItems } from '../../../../../../redux/customers/selector';
import { opportunities } from '../../../../../../redux/opportunities/action';
import { selectOpportunitiesListItems } from '../../../../../../redux/opportunities/selector';
import { organizationUnits } from '../../../../../../redux/organizationUnits/action';
import { selectOrganizationUnitsListItems } from '../../../../../../redux/organizationUnits/selector';
import { employees } from '../../../../../../redux/employees/action';
import { selectEmployeesListItems } from '../../../../../../redux/employees/selector';
import { selectTagNamesListItems } from '../../../../../../redux/tag-names/selector';
import { tagNames } from '../../../../../../redux/tag-names/action';
import { setDisplayText } from '../../../../../../common/services/tag-names.service';
import { termsLibraries } from '../../../../../../redux/terms-libraries/action';
import { selectTermsLibrariesListItems as selectTermLibrariesListItems } from '../../../../../../redux/terms-libraries/selector';
import { selectPriceBooksListItems } from '../../../../../../redux/pricing/price-books/selector';
import { priceBooks } from '../../../../../../redux/pricing/price-books/action';

let currentChange: any = {}
const SalesQuote = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectSalesQuotesQueryItems)
  const generateQuoteNumberItems = useSelector(selectSalesQuotesCreatedItem)
  const contactListItems = useSelector(selectContactsListItems)
  const customerListItems = useSelector(selectCustomersListItems)
  const opportunityListItems = useSelector(selectOpportunitiesListItems)
  const organizationUnitListItems = useSelector(selectOrganizationUnitsListItems)
  const employeeListItems = useSelector(selectEmployeesListItems)
  const priceBooksListItems = useSelector(selectPriceBooksListItems)
  const tagNameListItems = useSelector(selectTagNamesListItems)
  const termsLibraryItems = useSelector(selectTermLibrariesListItems);
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const librariesItems = storePersist?.get("library")?.current;
  const [selectedSalesQuote, setSelectedSalesQuote] = useState<any>([])
  const [selectedSalesQuoteNumber, setSelectedSalesQuoteNumber] = useState<any>([])
  const [combinations, setCombinations] = useState([])
  const [
    calculatedValues,
    setCalculatedValues
  ] = useState<any>({})
  const [
    selectedSalesQuoteItems,
    setSelectedSalesQuoteItems
  ] = useState<any>([])
  const fetchSalesQuoteById = () => {
    dispatch(salesQuotes.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/sales-quotes/query`,
      entity: 'salesQuotes',
      jsonData: {
        Records: [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedSalesQuote({ ...selectedSalesQuote, [field]: event });
  }

  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(selectedSalesQuoteItems);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setSelectedSalesQuoteItems(items);
  }

  const setCombinationInfo = async () => {
    let localSelectedSalesQuotes = deepCopy(selectedSalesQuoteItems)
    localSelectedSalesQuotes.splice(
      currentChange.idx,
      1,
      { ...localSelectedSalesQuotes[currentChange.idx] }
    );
    localSelectedSalesQuotes = addNewRow({ selectedSalesQuotesArg: localSelectedSalesQuotes });
    currentChange.field = 'QuantityDONE'
    setSelectedSalesQuoteItems(localSelectedSalesQuotes)
  }
  useEffect(
    () => {
      if (currentChange.field === 'Quantity') {
        setCombinationInfo()
      }
    },
    [selectedSalesQuoteItems]
  )

  const addNewRow = ({ selectedSalesQuotesArg }: any) => {
    const localSelectedSalesQuoteItems = deepCopy(selectedSalesQuotesArg)
    const newsSelectedSQdata = {
      Id: 0,
      SalesQuoteId: 0,
      Quantity: 1,
      SalesQuoteTaxAmount: 0,
      SalesQuoteTotalAmount: 0,
      SalesQuoteGrandTotal: 0,
      ProductAttributeCombinationId: 0,
      ProductId: 0,
      TaxPercentage: 0,
      DiscountPercentage: 0,
      UnitPriceInclTax: 0,
      UnitPriceExclTax: 0
    }
    if (localSelectedSalesQuoteItems.length === 0 ||
      localSelectedSalesQuoteItems[localSelectedSalesQuoteItems?.length - 1]?.Quantity !== 1 ||
      localSelectedSalesQuoteItems[localSelectedSalesQuoteItems?.length - 1]?.ProductAttributeCombinationId !== 0
    ) {
      localSelectedSalesQuoteItems?.push(newsSelectedSQdata)
    }
    return localSelectedSalesQuoteItems
  }

  useEffect(
    () => {

      if (isQuery) {
        setSelectedSalesQuote(queryItems?.result?.items)
        setCalculatedValues({
          ItemCount: queryItems?.result?.items?.TotalItemCount,
          TotalAmount: queryItems?.result?.items?.TotalAmount,
          TaxAmount: queryItems?.result?.items?.TaxAmount,
          GrandTotalAmount: queryItems?.result?.items?.GrandTotalAmount
        })
        const salesquoteItemsData: any = queryItems?.result?.items.map((item: any) => {
          const itemdData = {
            Id: item?.id,
            SalesQuoteId: item?.SalesQuoteId || 0,
            Quantity: item?.Quantity || 0,
            SalesQuoteTaxAmount: item?.SalesQuoteTaxAmount || 0,
            SalesQuoteTotalAmount: item?.SalesQuoteTotalAmount || 0,
            SalesQuoteGrandTotal: item?.SalesQuoteGrandTotal || 0,
            ProductAttributeCombinationId: item?.ProductAttributeCombinationId || 0,
            ProductId: item?.ProductId || 0,
            TaxPercentage: item?.TaxPercentage || 0,
            DiscountPercentage: item?.DiscountPercentage || 0,
            UnitPriceInclTax: item?.UnitPriceInclTax || 0,
            UnitPriceExclTax: item?.UnitPriceExclTax || 0,
          }
          return itemdData
        })
        const localSelectedSalesQuotes = addNewRow({ selectedSalesQuotesArg: salesquoteItemsData });
        setSelectedSalesQuoteItems(localSelectedSalesQuotes)
      }
    },
    [isQuery]
  )

  useEffect(
    () => {
      dispatch(customers.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/customers/list`,
        entity: 'customers',
        jsonData: {}
      })).then(() => {
        dispatch(opportunities.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/opportunities/list`,
          entity: 'opportunities',
          jsonData: {}
        }))
      }).then(() => {
        dispatch(contacts.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/contacts/list`,
          entity: 'contacts',
          jsonData: {}
        }))
      }).then(() => {
        dispatch(organizationUnits.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`,
          entity: 'organizationUnits',
          jsonData: {}
        }))
      }).then(() => {
        dispatch(employees.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/hrms/employees/list`,
          entity: 'employees',
          jsonData: {}
        }))
      }).then(() => {
        dispatch(priceBooks.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/pricing/price-books/list`,
          entity: 'priceBooks',
          jsonData: {}
        }))
      }).then(() => {
        dispatch(termsLibraries.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/contract/terms-libraries/list`,
          entity: 'termsLibraries',
          jsonData: {}
        }))
      }).then(() => {
        dispatch(tagNames.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/tag/tag-name/query-by-tag-name-list-value`,
          entity: 'tagNames',
          jsonData: {}
        }))
      }).then(() => {
        if (parmas?.id > 0) {
          fetchSalesQuoteById()
          setIsLoading(false)

        } else {
          const localSelectedSalesQuotes = addNewRow({ selectedSalesQuotesArg: selectedSalesQuoteItems });
          setSelectedSalesQuoteItems(localSelectedSalesQuotes)
          setIsLoading(false)
        }
      })
    },
    []
  )


  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    selectedSalesQuoteItems.splice(
      selectedSalesQuoteItems.length - 1,
      1
    )
    const salesquoteItemsData: any = selectedSalesQuoteItems?.map((item: any) => {
      const itemdData = {
        Id: item?.id,
        SalesQuoteId: item?.SalesQuoteId || 0,
        Quantity: item?.Quantity || 0,
        SalesQuoteTaxAmount: item?.SalesQuoteTaxAmount || 0,
        SalesQuoteTotalAmount: item?.SalesQuoteTotalAmount || 0,
        SalesQuoteGrandTotal: item?.SalesQuoteGrandTotal || 0,
        ProductAttributeCombinationId: item?.ProductAttributeCombinationId || 0,
        ProductId: item?.ProductId || 0,
        TaxPercentage: item?.TaxPercentage || 0,
        DiscountPercentage: item?.DiscountPercentage || 0,
        UnitPriceInclTax: item?.UnitPriceInclTax || 0,
        UnitPriceExclTax: item?.UnitPriceExclTax || 0,
      }
      return itemdData
    })
    selectedSalesQuote.QuoteItems = salesquoteItemsData
    const salesQuoteData = {
      Id: selectedSalesQuote?.Id || 0,
      ContactId: selectedSalesQuote?.ContactId || 0,
      CustomerId: selectedSalesQuote?.CustomerId || 0,
      OpportunityId: selectedSalesQuote?.OpportunityId || 0,
      BillingAddressId: selectedSalesQuote?.BillingAddressId || 0,
      ShippingAddressId: selectedSalesQuote?.ShippingAddressId || 0,
      PercentageOfPossisibilities: selectedSalesQuote?.PercentageOfPossisibilities || '',
      SalesPersonId: selectedSalesQuote?.SalesPersonId || 0,
      SalesQuoteNumber: selectedSalesQuoteNumber?.SalesQuoteNumber || '',
      OrganizationUnitId: selectedSalesQuote?.OrganizationUnitId || 0,
      PriceBookId: selectedSalesQuote?.PriceBookId || 0,
      TermLibraryId: selectedSalesQuote?.TermLibraryId || 0,
      SalesQuoteDateOnUtc: selectedSalesQuote?.SalesQuoteDateOnUtc || '',
      ValidUptoDateOnUtc: selectedSalesQuote?.ValidUptoDateOnUtc || '',
      DeliveryTimePeriod: selectedSalesQuote?.DeliveryTimePeriod || '',
      SQCreateSelectOptionId: selectedSalesQuote?.SQCreateSelectOptionId || 0,
      SalesQuoteRequirementFrequencyTypeId: selectedSalesQuote?.SalesQuoteRequirementFrequencyTypeId || 0,
      SalesQuotePriorityId: selectedSalesQuote?.SalesQuotePriorityId || 0,
      TransportationCharges: selectedSalesQuote?.TransportationCharges || 0,
      DiscountAmount: selectedSalesQuote?.DiscountAmount || 0,
      Remarks: selectedSalesQuote?.Remarks || '',
    }
    if (parmas?.id > 0) {
      await dispatch(salesQuotes.resetAction({ actionType: 'update' }))
      await dispatch(salesQuotes.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/sales-quotes`,
        entity: 'salesQuotes',
        jsonData: {
          Records: [
            salesQuoteData
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(salesQuotes.resetAction({ actionType: 'create' }))
      await dispatch(salesQuotes.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/sales-quotes`,
        entity: 'salesQuotes',
        jsonData: {
          Records: [
            salesQuoteData
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const generateSalesQuoteNumber = async () => {
    await dispatch(salesQuotes.resetAction({ actionType: 'create' }))
    await dispatch(salesQuotes.create({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/crm/sales-quotes/quote-number/generate`,
      entity: 'salesQuotes',
      jsonData: {}
    }))
    setSelectedSalesQuoteNumber(generateQuoteNumberItems?.result)
  }

  const getProductImage: any = (productId: any) => {
    const productImage = R.find(
      (product: any) => parseInt(
        product.Id,
        10
      ) === parseInt(
        productId,
        10
      ),
      combinations
    )
    return productImage?.ProductPictureURLs?.[0]?.ProductPictureURL ? productImage?.ProductPictureURLs[0]?.ProductPictureURL : '/src/assets/images/product-placeholder.png'
  }

  const back = () => {
    navigate('/management/sales/crm/salesquotes')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <SalesQuoteComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedSalesQuote={selectedSalesQuote}
          selectedSalesQuoteItems={selectedSalesQuoteItems}
          back={back}
          handleFormSubmit={handleFormSubmit}
          getProductImage={getProductImage}
          generateSalesQuoteNumber={generateSalesQuoteNumber}
          selectedSalesQuoteNumber={selectedSalesQuoteNumber}
          handleFormItemChange={handleFormItemChange}
          calculatedValues={calculatedValues}
          sQCreateSelectOption={librariesItems?.SQCreateSelectOption}
          customers={customerListItems?.result?.items}
          contacts={contactListItems?.result?.items}
          opportunities={opportunityListItems?.result?.items}
          employee={employeeListItems?.result?.items}
          organizationUnits={organizationUnitListItems?.result?.items}
          priceBooks={priceBooksListItems?.result?.items}
          termslibraries={termsLibraryItems?.result?.items}
          salesQuoteFrequency={librariesItems?.SalesQuoteRequirementFrequencyType}
          salesQuotePriority={librariesItems?.SalesQuotePriority}
          tagNames={setDisplayText(tagNameListItems?.result?.items)}
        />
      }
    </>
  )

}

export default SalesQuote;
